"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTools = exports.tools = void 0;
const hero_fleet_calculator_png_1 = __importDefault(require("../../images/hero-fleet-calculator.png"));
const hero_surplus_calculator_png_1 = __importDefault(require("../../images/hero-surplus-calculator.png"));
const hero_pools_png_1 = __importDefault(require("../../images/hero-pools.png"));
const hero_biofuel_switch_calculator_png_1 = __importDefault(require("../../images/hero-biofuel-switch-calculator.png"));
const auth_1 = require("../util/auth");
exports.tools = [
    {
        name: "Fleet Calculator",
        image: hero_fleet_calculator_png_1.default,
        description: "",
        path: "/fleet-calculator",
        adminOnly: false,
        public: false,
    },
    {
        name: "Surplus calculator",
        image: hero_surplus_calculator_png_1.default,
        description: "",
        path: "/surplus-calculator",
        adminOnly: true,
        public: false,
    },
    {
        name: "Biofuel Switch Calculator",
        image: hero_biofuel_switch_calculator_png_1.default,
        description: "Set the fuel switch you are considering and see the compliance surplus it generates, the FuelEU penalty that surplus avoids, the EU ETS cost it saves, and what the biofuel premium costs.",
        path: "/biofuel-switch-calculator",
        adminOnly: false,
        public: false,
    },
    {
        name: "Compliance Pooling",
        image: hero_pools_png_1.default,
        description: "",
        path: "/compliance",
        adminOnly: false,
        public: false,
    },
];
const getTools = (user, isAuthenticated) => exports.tools.filter((tool) => tool.adminOnly ? (0, auth_1.isAdmin)(user) : tool.public || isAuthenticated);
exports.getTools = getTools;
